import * as ConstantDev from '../Constants/dev'
import * as ConstantPilot from '../Constants/pilot'
import * as ConstantsBase from '../Constants/base'
import * as Config from '../Config/Config'
import * as ConstantProd from '../Constants/prod'

export function environmentConfig() {

  let requestUrl=''
  if (Config.ENVIRONMENT === 'DEV') {
    requestUrl = ConstantDev.baseUrl + ConstantsBase.apiUrl
  }
  else if (Config.ENVIRONMENT === 'UAT') {
    requestUrl = ConstantPilot.baseUrl + ConstantsBase.apiUrl
  }
  else if (Config.ENVIRONMENT === 'PROD') {
    requestUrl = ConstantProd.baseUrl + ConstantsBase.apiUrl
  }
  return requestUrl
}



export function destroySession(){
    sessionStorage.removeItem('firstName');
    sessionStorage.removeItem('lastName');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('isActive');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('startDate')
    sessionStorage.removeItem('endDate')
    sessionStorage.removeItem('selectedStore')
    sessionStorage.removeItem('arraySuppliername')
    sessionStorage.removeItem('vendorName')
}